/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './StatusSection.style';

const useStyles = createUseStyles(styles);

const StatusSection = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <ul className={classNames(classes.list, classes.blacks)}>
      <li className={classNames(classes.item, classes.success)}>
        <div className={classes.swatch}>Success </div>
      </li>
      <li className={classNames(classes.item, classes.warning)}>
        <div className={classes.swatch}>Warning </div>
      </li>
      <li className={classNames(classes.item, classes.error)}>
        <div className={classes.swatch}>Error </div>
      </li>
    </ul>
  );
};

export default compose(React.memo)(StatusSection);
